import React, { FC, memo } from 'react'
import styled from 'styled-components'
import { Picture } from '@ucheba/ui/components/Picture'
import { IGalleryItem } from '../types'

const Image = styled(Picture)`
  object-fit: cover;
`

const GalleryItem: FC<IGalleryItem> = (props) => {
  const { src, thumb, subHtml, alt, width, height, children, ...otherProps } = props

  const isIframe = src.includes('rutube')

  return (
    <a
      {...(isIframe ? { 'data-src': src, 'data-iframe': 'true' } : { href: src })}
      data-sub-html={subHtml}
      {...otherProps}
      rel='nofollow'
    >
      {children}

      <Image
        webpUrl={thumb?.webp}
        fallbackUrl={thumb?.fallbackUrl}
        alt={alt || 'Изображение'}
        width={width}
        height={height}
        loading='lazy'
      />
    </a>
  )
}

export default memo(GalleryItem)
